<script>
import useSharedSelectData from "@/use/SharedSelectData";
import {ref, watch} from "vue";

export default {
    props: {
        value: Object,
        pay_day_advance: Boolean,
    },
    setup(props, {emit}) {
        const {workerPhases, restStates, validationWorkFlowStatus} = useSharedSelectData();
        const panelModel = ref(0);

        const filter = ref({});

        watch(() => filter.value, () => {
            emit('input', filter.value);
        }, {deep: true});


        return {
            filter,
            workerPhases,
            restStates,
            validationWorkFlowStatus,
            panelModel
        }
    },
};
</script>

<template>
    <div>
        <v-expansion-panels v-model="panelModel" dense focusable>
            <v-expansion-panel>
                <v-expansion-panel-header>
                    <strong v-if="!pay_day_advance">
                        {{ $t("module.debt") }}
                    </strong>
                    <strong v-else>
                        {{ $t("module.pay_day_advance") }}
                    </strong>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="mr-n5 ml-n5">
                    <v-container fluid>
                        <v-row dense>
                            <v-col cols="12">
                                <str-worker-autocomplete
                                    v-model="filter.workerId"
                                    :label="$t('module.worker')"
                                ></str-worker-autocomplete>
                            </v-col>
                            <v-col cols="12">
                                <w-enum-select
                                    v-model="filter.restState"
                                    :label="$t('debts.refund_status')"
                                    :items="restStates"
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-date-picker
                                    v-model="filter.start"
                                    :label="$t('common.start')"
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-date-picker
                                    v-model="filter.end"
                                    :label="$t('common.end')"
                                />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
                <v-expansion-panel-header>
                    <strong>{{ $t('module.worker') }}</strong>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="mr-n5 ml-n5">
                    <v-container fluid>
                        <v-row dense>
                            <v-col cols="12">
                                <organizational-chart-select
                                    v-model="filter.organizationalchartIds"
                                    :label="$t('module.organizational_chart')"
                                />
                            </v-col>
                            <v-col cols="12">
                                <str-occupation-autocomplete
                                    v-model="filter.occupationId"
                                    :label="$t('module.occupation')"
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-data-select-autocomplete
                                    v-model="filter.workplaceId"
                                    type="WORKER_WORKPLACE"
                                    show-default-label
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-data-select-autocomplete
                                    v-model="filter.companyId"
                                    type="WORKER_COMPANY"
                                    show-default-label
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-data-select-autocomplete
                                    v-model="filter.stateId"
                                    type="WORKER_STATE"
                                    show-default-label
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-enum-select
                                    v-model="filter.phase"
                                    :items="workerPhases"
                                    :label="$t('worker.status')"
                                />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
                <v-expansion-panel-header>
                    <strong>{{ $t('common.validation') }}</strong>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="mr-n5 ml-n5">
                    <v-container fluid>
                        <v-row dense>
                            <v-col cols="12">
                                <w-enum-select
                                    v-model="filter.validationStatus"
                                    :items="validationWorkFlowStatus"
                                    :label="$t('common.state')"
                                    multiple
                                />
                            </v-col>
                            <v-col cols="12">
                                <str-step-select
                                    v-model="filter.lastState"
                                    :label="$t('common.validation')"
                                    module="TRAINING_REQUEST"
                                    by-name
                                ></str-step-select>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>

        <input type="hidden"/>
    </div>
</template>